/**
 * Portal Manta · ConhecimentoConsolidadoPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { S } from '../../globals.js';
import { KnowledgePage } from './KnowledgePage.jsx';
import { BenchmarkingPage } from './BenchmarkingPage.jsx';
import { OrcamentoConsolidadoPage } from './OrcamentoConsolidadoPage.jsx';

const ConhecimentoConsolidadoPage = memo(function ConhecimentoConsolidadoPage_Inner(){
  const [aba, setAba] = useState('kb');
  return (<div style={S.page}>
    <div style={S.h1}>📚 04 · Conhecimento Consolidado</div>
    <div style={S.sub}>Fusão de KB Curada (qualitativo) + KPIs Globais (quantitativo) + Orçamentação Consolidada (financeiro)</div>

    {/* Sub-abas */}
    <div style={{display:'flex', gap:0, marginBottom:14, background:'#fff', border:`1px solid ${M.border}`, borderRadius:6, overflow:'hidden'}}>
      {[
        {k:'kb',     n:'04.1', l:'KB Curada',                ic:'📖'},
        {k:'kpis',   n:'04.2', l:'KPIs Globais',             ic:'📊'},
        {k:'consol', n:'04.3', l:'Orçamentação Consolidada', ic:'💰'},
      ].map(t=>(
        <button key={t.k} onClick={()=>setAba(t.k)} style={{
          flex:1, padding:'10px 16px', fontSize:11.5, fontWeight:700,
          background:aba===t.k?M.accent:'transparent', color:aba===t.k?'#fff':M.text,
          border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8,
          fontFamily:F.body,
        }}>
          <span style={{fontFamily:F.mono, fontSize:9.5, opacity:0.8}}>{t.n}</span>
          <span style={{fontSize:14}}>{t.ic}</span>
          <span>{t.l}</span>
        </button>
      ))}
    </div>

    <div style={{background:'#fff', borderRadius:8, border:`1px solid ${M.border}`, overflow:'hidden'}}>
      {aba==='kb'     && <KnowledgePage/>}
      {aba==='kpis'   && <BenchmarkingPage/>}
      {aba==='consol' && <OrcamentoConsolidadoPage/>}
    </div>
  </div>);
});

export { ConhecimentoConsolidadoPage };
export default ConhecimentoConsolidadoPage;
